// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-data-preview {
  max-width: 320px;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--cms-mfe-color-border, #e2e8f0);
  border-radius: var(--cms-mfe-radius-sm, 6px);
  background: var(--cms-mfe-color-surface-elevated, #fff);
  font-size: 0.8125rem;
}

.card-data-preview__row {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  padding: 0.3rem 0;
}

.card-data-preview__row + .card-data-preview__row {
  border-top: 1px solid var(--cms-mfe-color-border, #e2e8f0);
}

.card-data-preview__label {
  font-size: 0.6875rem;
  color: var(--cms-mfe-color-text-muted, #64748b);
}

.card-data-preview__value {
  font-size: 0.8125rem;
  word-break: break-word;
}

.card-data-preview__mono {
  font-family: ui-monospace, 'Cascadia Code', 'Courier New', monospace;
  font-size: 0.75rem;
}
`, "",{"version":3,"sources":["webpack://./src/shared/ui/naqdpay-card/NaqdPayCard.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,sDAAsD;EACtD,4CAA4C;EAC5C,uDAAuD;EACvD,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,oEAAoE;EACpE,kBAAkB;AACpB","sourcesContent":[".card-data-preview {\r\n  max-width: 320px;\r\n  padding: 0.5rem 0.75rem;\r\n  border: 1px solid var(--cms-mfe-color-border, #e2e8f0);\r\n  border-radius: var(--cms-mfe-radius-sm, 6px);\r\n  background: var(--cms-mfe-color-surface-elevated, #fff);\r\n  font-size: 0.8125rem;\r\n}\r\n\r\n.card-data-preview__row {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.1rem;\r\n  padding: 0.3rem 0;\r\n}\r\n\r\n.card-data-preview__row + .card-data-preview__row {\r\n  border-top: 1px solid var(--cms-mfe-color-border, #e2e8f0);\r\n}\r\n\r\n.card-data-preview__label {\r\n  font-size: 0.6875rem;\r\n  color: var(--cms-mfe-color-text-muted, #64748b);\r\n}\r\n\r\n.card-data-preview__value {\r\n  font-size: 0.8125rem;\r\n  word-break: break-word;\r\n}\r\n\r\n.card-data-preview__mono {\r\n  font-family: ui-monospace, 'Cascadia Code', 'Courier New', monospace;\r\n  font-size: 0.75rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
